import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../style/HelpCenter.scss';
import { t } from '../../i18n';

const isMac = /Mac/.test(navigator.platform);
const MOD = isMac ? '⌘' : 'Ctrl';

const SHORTCUTS = [
  [`${MOD} K`, t('ui.help.sc.search')],
  [`${MOD} Z`, t('ui.help.sc.undo')],
  [`${MOD} ${t('ui.help.key.shift')} Z`, t('ui.help.sc.redo')],
  [`${MOD} D`, t('ui.help.sc.dup')],
  [isMac ? '⌫' : t('ui.help.key.del'), t('ui.help.sc.del')],
  [t('ui.help.key.esc'), t('ui.help.sc.esc')],
  ['?', t('ui.help.sc.help')],
];

const GLOSSARY = [
  [t('ui.gl.interface'), t('ui.gl.interface.def')],
  [t('ui.gl.page'), t('ui.gl.page.def')],
  [t('ui.gl.module'), t('ui.gl.module.def')],
  [t('ui.gl.publish'), t('ui.gl.publish.def')],
  [t('ui.gl.screen'), t('ui.gl.screen.def')],
  [t('ui.gl.preview'), t('ui.gl.preview.def')],
];

const TABS = [['start', t('ui.help.tab.start')], ['shortcuts', t('ui.help.tab.shortcuts')], ['glossary', t('ui.help.tab.glossary')]];

// Centre d'aide : démarrage rapide, raccourcis clavier, vocabulaire. S'ouvre avec « ? » ou depuis le menu.
class HelpCenter extends Component {

  state = { open: false, tab: 'start' };

  componentDidMount() {
    window.addEventListener('keydown', this.onKey);
    window.addEventListener('tsk-open-help', this.open);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKey);
    window.removeEventListener('tsk-open-help', this.open);
  }

  open = () => this.setState({ open: true, tab: 'start' });
  close = () => this.setState({ open: false });

  onKey = (e) => {
    const t = e.target;
    const typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable);
    if (e.key === 'Escape' && this.state.open) this.close();
    else if (e.key === '?' && !typing && !e.metaKey && !e.ctrlKey) this.open();
  };

  render() {
    const { open, tab } = this.state;
    if (!open) return null;
    return (
      <div className='tsk-ui-modal-overlay' onMouseDown={this.close}>
        <div className='tsk-ui-modal-surface tsk-help' role='dialog' aria-label={t('ui.help.title')} onMouseDown={(e) => e.stopPropagation()}>
          <h3 className='tsk-ui-modal__title'><FontAwesomeIcon icon={['fas', 'question-circle']} /> {t('ui.help.title')}</h3>
          <div className='tsk-segmented'>
            {TABS.map(([id, label]) => (
              <button key={id} type='button' className={tab === id ? 'is-active' : ''} onClick={() => this.setState({ tab: id })}>{label}</button>
            ))}
          </div>

          {tab === 'start' && (
            <div className='tsk-help__body'>
              <ol className='tsk-help__steps'>
                <li><strong>{t('ui.help.s1a')}</strong>{t('ui.help.s1b')}</li>
                <li><strong>{t('ui.help.s2a')}</strong>{t('ui.help.s2b')}</li>
                <li><strong>{t('ui.help.s3a')}</strong>{t('ui.help.s3b')}</li>
                <li><strong>{t('ui.help.s4a')}</strong>{t('ui.help.s4b')}<strong>{t('ui.help.s4c')}</strong>.</li>
              </ol>
              <button
                type='button'
                className='tsk-button'
                onClick={() => { this.close(); window.dispatchEvent(new Event('tsk-start-tour')); }}
              >
                {t('ui.help.tour')}
              </button>
            </div>
          )}

          {tab === 'shortcuts' && (
            <ul className='tsk-help__list'>
              {SHORTCUTS.map(([keys, label]) => (
                <li key={label}><kbd>{keys}</kbd><span>{label}</span></li>
              ))}
            </ul>
          )}

          {tab === 'glossary' && (
            <dl className='tsk-help__glossary'>
              {GLOSSARY.map(([term, def]) => (
                <div key={term}><dt>{term}</dt><dd>{def}</dd></div>
              ))}
            </dl>
          )}

          <div className='tsk-ui-modal__actions'>
            <button type='button' className='tsk-button' onClick={this.close}>{t('ui.common.close')}</button>
          </div>
        </div>
      </div>
    );
  }
}

export default HelpCenter;
